// removed by extract-text-webpack-plugin
module.exports = {"content":"EditAppointment__content___1uVTz","container":"EditAppointment__container___2ck65"};